import { debug, UNHANDLED } from '../../../utils';
import { fetchPlace, fetchPlaces, postReviews } from './actions';

const log = debug('lego:models/Places');

// const getPlace = (id) => (
//     dispatch => api.getPlace(id)
//         .then(data => {
//             dispatch(actions.upsertPlaces([data]));
//         })
//         .catch(UNHANDLED()));


// const fetch = fetch.start;
// const postReviews = postReviews.start;

import pickBy from 'lodash/pickBy';
const getPlaces = (state) => state.places;
const getPlacesById = (state, props) => pickBy(state.places, props.ids);


export { fetchPlace, fetchPlaces, postReviews, getPlaces, getPlacesById };



// WEBPACK FOOTER //
// ./src/app/models/Places/index.ts